export default "__VITE_ASSET__9affa8fa__"